import React from "react"
import observ from 'observ'
import moment from 'moment-timezone'

function pad (val) {
    return (val < 10) ? 
        ('0' + val) : val
}

class StreamTimer extends React.Component {
    constructor (props) {
        super(props)

        let self = this

        this.state = {
            focused: observ(document.hasFocus()),
            timer: null
        }

        this.blurListener = () => self.state.focused.set(false)
        this.focusListener = () => self.state.focused.set(true)
        window.addEventListener('blur', this.blurListener)
        window.addEventListener('focus', this.focusListener)

        this.state.focused(function onChange (isfocused) {
            if (isfocused) {
                self.start()
            } else {
                self.stop()
            }
        })

        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)
    }

    componentDidMount () {
        this.start();
    }

    componentWillUnmount () {
        window.removeEventListener('blur', this.blurListener)
        window.removeEventListener('focus', this.focusListener)
        clearTimeout(this.state.timer)
    }

    start () {
        let self = this
        function handleUpdate () {
            self.setState({
                // recursively call this fn so it keeps going
                // each iteration represents a "tick" in seconds
                timer: (self.state.focused() ? 
                    setTimeout(handleUpdate, 1000) : null
                )
            })
        }
        setTimeout(handleUpdate, 0);
    }

    stop () {
        this.setState(state => ({
            timer: (() => {
                clearTimeout(state.timer)
                return null
            })()
        }))
    }

    render () {
        let { event, timeZone } = this.props
        let { startDate } = event.liveStats

        let mStartDate = moment.tz(startDate, timeZone)
        let mUTCStartDate = moment.utc(mStartDate)
        let mLOCALStartDate = moment(mUTCStartDate).local()

        let now = moment()
        let diff = moment.duration(now.diff(mLOCALStartDate))

        let days = diff.days()
        let hours = pad(diff.hours())
        let minutes = pad(diff.minutes())
        let seconds = pad(diff.seconds())

        let styles = (!this.state.focused()) ? {
            color: 'transparent',
            textShadow:'0 0 5px rgba(0,0,0,0.5)'
        } : {}

        return <span style={styles}>
                {(days > 0) ? days : null} {[hours,minutes,seconds].join(':')}
        </span>
    }
}

export default StreamTimer